// src/api/authService.js
// Handles authentication API calls

// REACT_APP_API_URL should be the API root (e.g., http://localhost:8080/api)
const API_ROOT = process.env.REACT_APP_API_URL || "http://localhost:8080/api";
const API_ORIGIN = API_ROOT.replace(/\/api\/?$/, '');
const API_URL = `${API_ROOT}/auth`;

export async function login(email, password) {
  const res = await fetch(`${API_URL}/login`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ email, password })
  });
  if (!res.ok) throw new Error(await res.text());
  return res.json(); // { token }
}

export async function register(data) {
  const res = await fetch(`${API_URL}/register`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data)
  });
  if (!res.ok) throw new Error(await res.text());
  return res.json();
}

export async function getProfile(token) {
  const res = await fetch(`${API_URL}/profile`, {
    headers: { "Authorization": `Bearer ${token}` }
  });
  if (!res.ok) throw new Error(await res.text());
  return res.json();
}

export async function updateProfile(partial, token) {
  const res = await fetch(`${API_URL}/profile`, {
    method: 'PATCH',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${token}`
    },
    body: JSON.stringify(partial)
  });
  if (!res.ok) throw new Error(await res.text());
  return res.json();
}

export async function uploadImage(file, token) {
  const form = new FormData();
  form.append('file', file);
  const res = await fetch(`${API_ROOT}/upload/image`, {
    method: 'POST',
    headers: token ? { 'Authorization': `Bearer ${token}` } : undefined,
    body: form
  });
  if (!res.ok) throw new Error(await res.text());
  const data = await res.json(); // { url: '/uploads/...' }
  if (data?.url?.startsWith('/')) {
    data.absoluteUrl = `${API_ORIGIN}${data.url}`;
  }
  return data;
}
